import React, { useEffect } from 'react';
import { MenuItem, Select, CircularProgress } from '@mui/material';
import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';
import { useCompanyConfiguration } from '../../hooks/useCompanyConfiguration';

export const CompanySelector = () => {
    const {
        userCompanies,
        selectedCompanyId,
        isLoading,
        changeCompany,
        hasMultipleCompanies,
        init,
    } = useCompanyConfiguration();

    useEffect(() => {
        if (userCompanies.length === 0) {
            init();
        }
    }, []);

    if (isLoading && userCompanies.length === 0) {
        return <CircularProgress size={20} sx={{ color: 'white', ml: 1 }} />;
    }

    if (!hasMultipleCompanies) {
        return null;
    }

    return (
        <Select
            value={selectedCompanyId || ''}
            onChange={(e) => changeCompany(e.target.value)}
            size="small"
            variant="standard"
            disableUnderline
            IconComponent={BusinessRoundedIcon}
            displayEmpty
            sx={{
                backgroundColor: 'transparent',
                color: (theme) => theme.navbar.text,
                fontSize: 14,
                minWidth: 180,
                '& .MuiSelect-select': {
                    paddingRight: '30px !important',
                    paddingLeft: '8px !important',
                    marginTop: '5px',
                },
                '& .MuiSelect-icon': {
                    color: 'primary.main',
                    right: '0px',
                    fontSize: '22px',
                },
                '& .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                },
            }}
        >
            <MenuItem
                key={''}
                value={''}
                sx={{ color: 'text.primary' }}
            >
                Seleccione una compañia
            </MenuItem>
            {userCompanies.map((company) => (
                <MenuItem
                    key={company.id_company}
                    value={company.id_company}
                    sx={{ color: 'text.primary' }}
                >
                    {company.name}
                </MenuItem>
            ))}
        </Select>
    );
};

export default CompanySelector;